export default __webpack_public_path__ + "static/media/external-link.f2286011.svg";